import type { CapabilityMap, RoleResponse } from '../../lib/api-client';

const CAPS: (keyof CapabilityMap)[] = ['full_access', 'manage_users', 'manage_roles', 'manage_agents', 'creator_mode', 'sftp_access'];

/**
 * Mirror of the backend capability-subset rule: an actor may assign a role only
 * if the role's capabilities are a subset of the actor's (or the actor has
 * full_access). Used to filter the assignable-role dropdowns. The server
 * enforces this regardless; this is purely UX (hide what would be rejected).
 */
export function capabilitiesSubsetOf(child: CapabilityMap, parent: CapabilityMap): boolean {
  if (parent.full_access === true) return true;
  for (const cap of CAPS) {
    if (child[cap] === true && parent[cap] !== true) return false;
  }
  return true;
}

export function assignableRoles(roles: RoleResponse[], actorCaps: CapabilityMap): RoleResponse[] {
  return roles.filter((r) => capabilitiesSubsetOf(r.capabilities, actorCaps));
}
